
(function () {
  'use strict';

  var READY_EVENT = 'adobe-target:decisions-ready';
  var FAILSAFE_WAIT_MS = 1500;
  var PRE_HIDE_STYLE_ID = 'at-body-style';
  var COOKIE_DAYS = 90;

  var PERSISTED_KEYS = {
    price_v2: 'rm_seg',
  };

  var VALID_GROUP_VALUES = ['1', '2'];

  function isValidGroupValue(value) {
    return VALID_GROUP_VALUES.indexOf(value) !== -1;
  }

  window.expFlags = window.expFlags || {};
  window.rmPersistedFlags = window.rmPersistedFlags || {};

  var alreadyAssigned = {};

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  }

  function setCookie(name, value, days) {
    var expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString();
    document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + expires + '; path=/; SameSite=Lax';
  }

  function removePreHideStyle() {
    var el = document.getElementById(PRE_HIDE_STYLE_ID);
    if (el && el.parentNode) el.parentNode.removeChild(el);
  }

  
  function applyAll() {
    var groups = {};

    document.querySelectorAll('[data-pg-value]').forEach(function (el) {
      var key = el.getAttribute('data-pg');
      if (!key) return;
      groups[key] = groups[key] || [];
      groups[key].push(el);
    });

    Object.keys(groups).forEach(function (key) {
      var elements = groups[key];
      var fallback = elements[0].getAttribute('data-pg-default') || '1';
      var chosen = window.expFlags[key] || fallback;
      var matched = false;

      elements.forEach(function (el) {
        var isMatch = el.getAttribute('data-pg-value') === chosen;
        el.hidden = !isMatch;
        if (isMatch) matched = true;
      });

      
      if (!matched) {
        chosen = fallback;
        elements.forEach(function (el) {
          el.hidden = el.getAttribute('data-pg-value') !== fallback;
        });
      }

      if (!alreadyAssigned[key] && window.dataLayer) {
        alreadyAssigned[key] = true;
        window.dataLayer.push({ event: 'pg_assigned', pg_key: key, pg_value: chosen });
      }
    });

    
    Object.keys(window.expFlags).forEach(function (key) {
      document.dispatchEvent(new CustomEvent('pg:resolved', { detail: { key: key, value: window.expFlags[key] } }));
    });

    removePreHideStyle();
  }

  
  function canUseUrlOverrides() {
    var shopify = window.Shopify || {};
    if (shopify.designMode) return true;
    return !!(shopify.theme && shopify.theme.role && shopify.theme.role !== 'main');
  }

  function applyUrlOverrides() {
    if (!canUseUrlOverrides()) return false;

    var params = new URLSearchParams(window.location.search);
    var found = false;

    params.forEach(function (value, name) {
      if (name.indexOf('exp_') !== 0) return;
      window.expFlags[name.slice('exp_'.length)] = value;
      found = true;
    });

    return found;
  }

  
  function seedPersistedFlags() {
    var stored = {};

    Object.keys(PERSISTED_KEYS).forEach(function (key) {
      var cookieName = PERSISTED_KEYS[key];
      var cookieValue = getCookie(cookieName);
      if (cookieValue && !isValidGroupValue(cookieValue)) cookieValue = null;

      var value = cookieValue || window.rmPersistedFlags[key];
      if (!value) return;

      window.expFlags[key] = value;
      stored[key] = value;
      setCookie(cookieName, value, COOKIE_DAYS);
    });

    return stored;
  }

  
  function persistResolvedFlags() {
    Object.keys(PERSISTED_KEYS).forEach(function (key) {
      var cookieName = PERSISTED_KEYS[key];
      var value = window.expFlags[key];
      if (value) setCookie(cookieName, value, COOKIE_DAYS);
    });
  }

  
  function reconcileAgainstStored(stored) {
    Object.keys(stored).forEach(function (key) {
      var fresh = window.expFlags[key];
      if (fresh && fresh !== stored[key] && window.dataLayer) {
        window.dataLayer.push({ event: 'pg_mismatch', pg_key: key, pg_stored: stored[key], pg_fresh: fresh });
      }
      window.expFlags[key] = stored[key];
    });
  }

  function resolve() {
    if (applyUrlOverrides()) {
      applyAll();
      
      persistResolvedFlags();
      return;
    }

    var stored = seedPersistedFlags();
    var persistedKeys = Object.keys(PERSISTED_KEYS);
    var allStored =
      persistedKeys.length > 0 &&
      persistedKeys.every(function (key) {
        return !!stored[key];
      });

    if (allStored) {
      
      applyAll();
      document.addEventListener(READY_EVENT, function () {
        reconcileAgainstStored(stored);
      });
      return;
    }

    var revealedByTimeout = false;

    
    var failsafeTimer = setTimeout(function () {
      revealedByTimeout = true;
      applyAll();
    }, FAILSAFE_WAIT_MS);

    document.addEventListener(READY_EVENT, function () {
      clearTimeout(failsafeTimer);
      reconcileAgainstStored(stored);

      if (revealedByTimeout) {
        
        persistResolvedFlags();
        return;
      }

      applyAll();
      persistResolvedFlags();
    });
  }

  
  function watchForDynamicContent() {
    if (typeof MutationObserver === 'undefined') return;

    var observer = new MutationObserver(function (mutations) {
      var hasNewPg = mutations.some(function (mutation) {
        return Array.prototype.some.call(mutation.addedNodes, function (node) {
          if (node.nodeType !== 1) return false;
          return node.matches('[data-pg-value]') || !!node.querySelector('[data-pg-value]');
        });
      });
      if (hasNewPg) applyAll();
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState !== 'loading') {
    resolve();
    watchForDynamicContent();
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      resolve();
      watchForDynamicContent();
    });
  }
})();
